import { C4ListResponse } from '@domain/interface/c4-list-response';
import { createAction, props } from '@ngrx/store';
import { ImportStatsTable, Owner } from 'cargo-chief-commons';

export const AUTOMATION_TRANSACTIONS = {
	TRANSACTIONS_LIST: {
		GET: createAction('[Automation Transactions] Get transactions', props<any>()),
		SUCCESS: createAction(
			'[Automation Transactions] Get transactions success',
			props<C4ListResponse<ImportStatsTable>>()
		),
		FAILURE: createAction(
			'[Automation Transactions] Get transactions failure',
			props<{ payload: { message: string } }>()
		),
	},

	STATS: {
		TRANSACTIONS_COUNT: {
			GET: createAction(
				'[Automation Transactions Stats] Get total transactions count',
				props<any>()
			),
			SUCCESS: createAction(
				'[Automation Transactions Stats] Get total transactions count success',
				props<any>()
			),
			FAILURE: createAction(
				'[Automation Transactions Stats] Get total transactions count failure',
				props<{ payload: { message: string } }>()
			),
		},
		THIS_MONTH: {
			SUCCESS: createAction(
				'[Automation Transactions] Get transactions this month success',
				props<C4ListResponse<ImportStatsTable>>()
			),
		},
		PRICING: {
			SUCCESS: createAction(
				'[Automation Transactions] Get transactions success by pricing',
				props<C4ListResponse<ImportStatsTable>>()
			),
		},
	},

	SORT: {
		SET: createAction('[SORT] Transactions Automation Set sort', props<{ sort: any[] }>()),
	},

	FILTERS: {
		SET: createAction('[FILTERS] Transactions Automation Set filters', props<{ filters: any[] }>()),
	},

	USERS_LIST: {
		SET: createAction(
			'[UsersList] Set Users List for transactions automation',
			props<{ usersList: Owner[] }>()
		),
	},

	ACTIVE_TAB: {
		SET: createAction(
			'[ACTIVE_TAB] Automation Transactions Set ACTIVE_TAB',
			props<{ activeTab: string }>()
		),
	},

	IMPORT_TRANSACTIONS_UPLOAD_FILE: {
		OPEN_DIALOG: createAction(
			'[Automation Transactions] open import transactions dialog',
			props<any>()
		),
		CLOSE_DIALOG: createAction(
			'[Automation Transactions] close import transactions dialog',
			props<any>()
		),
		UPLOAD: createAction('[Automation Transactions] import transactions', props<any>()),
		SUCCESS: createAction('[Automation Transactions] import transactions success', props<any>()),
		FAILURE: createAction(
			'[Automation Transactions] import transactions failure',
			props<{ payload: { message: string } }>()
		),
	},

	IMPORT_STAT: {
		ADD: createAction('[Automation Transactions] Import stat added', props<any>()),
		UPDATE: createAction('[Automation Transactions] Import stat updated', props<any>()),
	},
};
